import React from 'react' 
import classnames from 'classnames'
import './press.css'

const PressModule = ({
  coverImage,
  fileDownload,
  fileType,
  category,
  title, 
  subtitle }) => {

  const moduleClassNames = classnames({
    'press-module--active': true,
  }, 'press-module')

  return (
    fileDownload ?
    <div className={moduleClassNames}>
      <div className="press-module__content">
        <a className="press-module__link" href={fileDownload.url} download target="__blank">
          <div className="folder__wrapper">
            <div className="folder">
              <div className="folder__layer folder__front"></div>
              <div 
                style={{
                  backgroundImage: `url(${coverImage.imageSource})`
                }}
                className="folder__layer folder__file"></div>
              <div className="folder__layer folder__back"></div>
            </div>
          </div>
          <div className="press-module__text">
            <div className="press-module__title text--small">{title}</div>
            <div className="press-module__subtitle text--small">{subtitle}</div>
            <div className="press-module__category text--small">
              {`${category}${fileType}`}
            </div>
          </div>
        </a>
      </div>
    </div>
    : null
  )
}

export default PressModule


// WEBPACK FOOTER //
// ./src/components/artist-press-module/index.js